export const required = {
  required: true,
  message: "Field is Required",
};

export const maxLength = (length?: number) => ({
  max: length || 255,
  message: `Field Must be less than ${length || 255} chars`,
});

export const mailType = {
  type: "email",
  message: "Please enter a valid email!",
};
